import moment from "moment";
import { formatSpeedAtImpact, formatAccelaration } from "./unit";

// speed data array for chart
export const getSpeedData = (crashTransport) => {
  const speedArray = crashTransport.timelineEvent.trajectory.map((p) => ({
    x: p.timestamp,
    y: p.speedV2.toFixed(2),
  }));
  return speedArray;
};

// accelaration data array for chart
export const getAccelarationData = (data) => {
  const accelarationxArray = data.crashEvent.sensorData.measurements[0].map(
    (p) => p * p
  );
  const accelarationyArray = data.crashEvent.sensorData.measurements[1].map(
    (p) => p * p
  );
  const accelarationzArray = data.crashEvent.sensorData.measurements[2].map(
    (p) => p * p
  );
  const arrAccelaration = [];
  for (let i = 0; i < accelarationxArray.length; i++) {
    arrAccelaration[i] = {
      y: (
        Math.sqrt(
          accelarationxArray[i] + accelarationyArray[i] + accelarationzArray[i]
        ) * 9.81
      ).toFixed(2),
      x:
        data.crashEvent.sensorData.baseOffsets[i] +
        data.crashEvent.sensorData.baseTimestamp,
    };
  }

  console.log({ arrAccelaration });
  return arrAccelaration;
};

// return to title and labels of tooltips
export const getTooltipTitle = (tooltipItems) => {
  const date = moment(tooltipItems[0].label, "HH:mm:ss").format("HH:mm:ss");
  const speed = tooltipItems.find(p => p.datasetIndex === 0);
  const acc = tooltipItems.find(p => p.datasetIndex === 1);
  const lines = [
    date,
    speed && speed.yLabel && `Speeding: ${formatSpeedAtImpact(speed.yLabel)}`,
    acc && acc.yLabel && `Acceleration: ${formatAccelaration(acc.yLabel)}`,
  ];
  return lines.join("\n");
};
